import { useTtDetails } from '../../TtDetails';
import { NoteReceivable, PersonalPropertyItem } from '../../generated/graphql';
import { NotesReceivableTableContainer } from './NoteReceivableTableContainer';
import { NoteReceivableSumTableItem } from './NoteReceivableSumTableItem';
import { PersonalPropertyItemsTableContainer } from './PersonalPropertyItemTableContainer';
import { PersonalPropertyItemSumTableItem } from './PersonalPropertyItemSumTableItem';
import clsx from 'clsx';

interface PersonalFinancialStatementOtherAssetsTableProps {
  householdID: string;
  onNoteReceivableItemClicked?: (a: { noteReceivable: NoteReceivable }) => void;
  onPersonalPropertyItemClicked?: (a: { personalPropertyItem: PersonalPropertyItem }) => void;
  personalPropertyItemTableTitleClassName?: string;
  noteReceivablesTableTitleClassName?: string;
}

export function PersonalFinancialStatementOtherAssetsTable({
  householdID,
  onNoteReceivableItemClicked,
  onPersonalPropertyItemClicked,
  personalPropertyItemTableTitleClassName,
  noteReceivablesTableTitleClassName,
}: PersonalFinancialStatementOtherAssetsTableProps) {
  const { ttDetails, ttDetailsQuery } = useTtDetails({ householdID, includeAssetSummary: true });

  return (
    <>
      <PersonalPropertyItemsTableContainer
        isLoading={ttDetailsQuery.isLoading}
        className="mb-4 md:mb-[47px] last:mb-6"
        tableRowsContainerClassName="mt-[2px]"
        tableTitleClassName={clsx(
          personalPropertyItemTableTitleClassName,
          'sticky top-[56px] z-[1] bg-darkMode-gray-background'
        )}
        personalPropertyItemArray={Array.from(ttDetails?.assetSummary.personalPropertyItems || []).sort((a, b) =>
          a.name.localeCompare(b.name)
        )}
      >
        {({ personalPropertyItem }) => (
          <PersonalPropertyItemSumTableItem
            key={personalPropertyItem.id}
            personalPropertyItem={personalPropertyItem}
            onItemClicked={onPersonalPropertyItemClicked}
            className="focus:shadow-classic"
          />
        )}
      </PersonalPropertyItemsTableContainer>
      <NotesReceivableTableContainer
        isLoading={ttDetailsQuery.isLoading}
        tableRowsContainerClassName="mt-[2px]"
        className="mb-4 md:mb-[47px] last:mb-6"
        tableTitleClassName={clsx(
          noteReceivablesTableTitleClassName,
          'sticky top-[56px] z-[1] bg-darkMode-gray-background'
        )}
        noteReceivableArray={Array.from(ttDetails?.assetSummary.noteReceivables || []).sort((a, b) =>
          a.name.localeCompare(b.name)
        )}
      >
        {({ noteReceivable }) => (
          <NoteReceivableSumTableItem
            key={noteReceivable.id}
            noteReceivable={noteReceivable}
            onItemClicked={onNoteReceivableItemClicked}
            className="focus:shadow-classic"
          />
        )}
      </NotesReceivableTableContainer>
    </>
  );
}
